/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import ContactsIcon from "../../../assets/icons/contacts_main.svg2";
import HelpButton from "../../HelpContent/HelpButton";
import NewFeature from "../../Builder/Components/NewFeature";
import { Form } from "react-bootstrap";

export default function ContactsWidget() {
  const [period, setPeriod] = useState("");

  const [total, setTotal] = useState(0);
  const [processCount, setProcessCount] = useState(0);



  return (
    <div className="position-relative px-2 d-flex flex-column h-100">
      <div className="d-flex p-3 pb-1 align-items-center ">
        <ContactsIcon width={20} className="white opacity-50" />
          <Link className="btn p-0 text-white" to="/assets/contacts/all">
        <h6 className="m-0 mx-2 small fw-bold">
           CONTACTS
          </h6>
        </Link>
        <HelpButton helpKey="widget-contacts" iconClassName="white" />
        <FontAwesomeIcon
          icon={faGripVertical}
          className="ms-4 opacity-50 widget-header"
        />
      </div>
      <div className="overflow-auto">
        {[
          {
            label: <div className="opacity-50">Total contacts</div>,
            value: `${total}`,
          },

          {
            label: <div className="opacity-50">Summary of missing data</div>,
            value: <div></div>,
          },
          {
            label: <div className="opacity-50">Self-managed</div>,
            value: (
              <div >
                <Form.Check // prettier-ignore
                  type="switch"
                  id="selfManage-switch"
                  className="m-0 p-0"
                />
              </div>
            ),
          },
          {
            label: <div className="opacity-50">Last updated</div>,
            value: <div className="small"> 02/09/2025</div>,
          },
          {
            label: (
              <div className="opacity-50">
                Number of Failed messages associated to contacts
              </div>
            ),
            value: <div>{processCount}</div>,
          },
          {
            label: <div className="opacity-50">Last data import</div>,
            value: <div className="small">01/09/2025</div>,
          },
        ].map((r, i) => (
          <React.Fragment key={i}>
            <hr className="m-1" />
            <div className="d-flex justify-content-between px-3">
              <span className="fw-bold p-1">{r.label}</span>
              <h3 className="fw-bold m-0 p-1">{r.value}</h3>
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="flex-grow-1" />
    </div>
  );
}
